module.exports = __webpack_public_path__ + "8e06a45f01b1af5da98236f0f04bf3.png";